import util from '@bmp-vue/core/api/util'

const controller = 'Parceiros'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetAllApiKeysByCodigo: function (codigoParceiro, tipoIntegracao) {
        return util.Axios.GetAll(`${controller}/${codigoParceiro}/ApiKeys?tipoIntegracao=${tipoIntegracao}`)
    },
    GerarApiKey: function (codigoParceiro, tipoIntegracao) {
        return util.Axios.Post(`${controller}/${codigoParceiro}/ApiKey/Gerar?tipoIntegracao=${tipoIntegracao}`,
            { codigo: codigoParceiro })
    },
    GetAuth: function (codigoParceiro) {
        return util.Axios.Get(`${controller}/${codigoParceiro}/autenticacao-callback`)
    },
    GetAdesao: function (codigoParceiro) {
        return util.Axios.Get(`${controller}/${codigoParceiro}/adesao`)
    },
    UpdateAdesao: function (codigoParceiro, dto) {
        return util.Axios.Put(`${controller}/${codigoParceiro}/adesao`, '', dto)
    },
    UpdateAutenticacao: function (codigoParceiro, dto) {
        return util.Axios.Put(`${controller}/${codigoParceiro}/autenticacao-callback`, '', dto)
    },
    PostHeader: function (codigoParceiro, dto) {
        return util.Axios.Post(`${controller}/${codigoParceiro}/headers`,
            { codigoParceiro: codigoParceiro, ...dto })
    },
    PostScope: function (codigoParceiro, dto) {
        return util.Axios.Post(`${controller}/${codigoParceiro}/scopes`,
            { codigoParceiro: codigoParceiro, ...dto })
    },
    UpdateHeader: function (codigoParceiro, codigoHeader, dto) {
        return util.Axios.Put(`${controller}/${codigoParceiro}/headers/${codigoHeader}`, '', dto)
    },
    UpdateScope: function (codigoParceiro, codigoScope, dto) {
        return util.Axios.Put(`${controller}/${codigoParceiro}/scopes/${codigoScope}`, '', dto)
    },
    GetAllHeaders: function (codigoParceiro) {
        return util.Axios.GetAll(`${controller}/${codigoParceiro}/headers`)
    },
    GetAllScopes: function (codigoParceiro) {
        return util.Axios.GetAll(`${controller}/${codigoParceiro}/scopes`)
    },
    GetParceirosAtivos: function () {
        return util.Axios.GetAll(`${controller}/ativo`)
    },
    GetAllEnvioNotificacaoTed: function(dto) {
        return util.Axios.GetAll(`${controller}/relatorios/envio-notificacao-ted`, dto)
    },
    GetAllEnvioNotificacaoTedDetalhe: function(codigoSaldoEc) {
        return util.Axios.GetAll(`${controller}/relatorios/envio-notificacao-ted/${codigoSaldoEc}`)
    },
    ReprocessarCallback: function(codigoEc) {
        return util.Axios.Post(`${controller}/reprocessar/callback/${codigoEc}`)
    },
    AdicionarTentativas: function(codigoEc) {
        return util.Axios.Post(`${controller}/reprocessar/adicionar-tentativas/${codigoEc}`)
    },
    GetAllParceiroAdesaoNotificacaoTed: function () {
        return util.Axios.GetAll(`${controller}/notificar/ted`)
    },
    TestarConexao: function (codigoParceiro, tipoAuth) {
        return util.Axios.Post(`${controller}/${codigoParceiro}/testar-conexao/${tipoAuth}`)
    },
    GetTestesConexoesParceiro: function (codigoParceiro) {
        return util.Axios.GetAll(`${controller}/${codigoParceiro}/testes-conexao`)
    },
    GetLogTestesCurl: function (codigoParceiro, codigoLog) {
        return util.Axios.Get(`${controller}/${codigoParceiro}/testes-conexao/${codigoLog}/curl`)
    },
    GetLogTestesRetorno: function (codigoParceiro, codigoLog) {
        return util.Axios.Get(`${controller}/${codigoParceiro}/testes-conexao/${codigoLog}/retorno`)
    },
    GetLogTestesExceptionMessage: function (codigoParceiro, codigoLog) {
        return util.Axios.Get(`${controller}/${codigoParceiro}/testes-conexao/${codigoLog}/exception`)
    },
    ImportarLote: function (dto, codigoParceiro) {
        return util.Axios.PostForm(`${controller}/${codigoParceiro}/notificacao-ted/lote`, dto)
    }
})
